// extracted by mini-css-extract-plugin
export default {"hideTooltip":"F_-z","fadeIn":"G_-z","delay":"H_-z","recommendedSizeTooltip":"I_-z"};